import React from "react";
import classNames from "classnames/bind";
import ListTab from "../ListTab";
import UserList from "../UserList";
import User from "../User";
import styles from "./index.module.scss";
import {VOICE_CHAT_TYPE} from "utils/constants";

const List = ({
  voiceChatType,
  userList,
  miniMode,
  privateTab,
  currentChatMode,
  volumeData,
  privateChatStatus,
  onClickPrivateTab,
  getUserAttributes,
  sendCall,
  callId,
  setVolume,
  onClickLeaveChat,
  onClickEnterChat,
  agoraPrivateClient,
  worldName,
}) => {
  const cn = classNames.bind(styles);
  return (
    <div className={cn("voice_chat_list", miniMode && "mini_mode")}>
      {voiceChatType === VOICE_CHAT_TYPE[0] ? (
        <WorldChatList
          cn={cn}
          userList={userList}
          volumeData={volumeData}
          voiceChatType={voiceChatType}
          getUserAttributes={getUserAttributes}
          currentChatMode={currentChatMode}
          worldName={worldName}
        />
      ) : (
        <PrivateChatList
          cn={cn}
          userList={userList}
          voiceChatType={voiceChatType}
          privateTab={privateTab}
          privateChatStatus={privateChatStatus}
          onClickPrivateTab={onClickPrivateTab}
          getUserAttributes={getUserAttributes}
          sendCall={sendCall}
          callId={callId}
          setVolume={setVolume}
          onClickLeaveChat={onClickLeaveChat}
          onClickEnterChat={onClickEnterChat}
          agoraPrivateClient={agoraPrivateClient}
          currentChatMode={currentChatMode}
        />
      )}
    </div>
  );
};

const WorldChatList = ({
  cn,
  userList,
  voiceChatType,
  getUserAttributes,
  currentChatMode,
  worldName,
  volumeData,
}) => {
  return (
    <div className={cn("world_chat_list")}>
      <div className={cn("world_chat_info")}>
        <p className={cn("room_name")}>{worldName}</p>
        {currentChatMode === VOICE_CHAT_TYPE[0] && (
          <p className={cn("room_count")}>
            {userList.length + (currentChatMode === VOICE_CHAT_TYPE[0] ? 1 : 0)}
            /20
          </p>
        )}
      </div>
      <UserList
        userList={userList}
        volumeData={volumeData}
        voiceChatType={voiceChatType}
        getUserAttributes={getUserAttributes}
        currentChatMode={currentChatMode}
      />
    </div>
  );
};

const PrivateChatList = ({
  cn,
  userList,
  voiceChatType,
  privateTab,
  privateChatStatus,
  onClickPrivateTab,
  sendCall,
  callId,
  getUserAttributes,
  onClickLeaveChat,
  onClickEnterChat,
  agoraPrivateClient,
  currentChatMode,
}) => {
  let user = null;
  if (privateChatStatus === "meeting") {
    user = {uid: callId};
  }
  return currentChatMode === VOICE_CHAT_TYPE[1] &&
    privateChatStatus === "meeting" ? (
    <div className={cn("private_connect")}>
      <User
        user={user}
        isWorldTab={false}
        privateChatStatus={privateChatStatus}
        micStatus={
          agoraPrivateClient.remoteUsers[0] &&
          agoraPrivateClient.remoteUsers[0].hasAudio
        }
        sendCall={sendCall}
        getUserAttributes={getUserAttributes}
        onClickLeaveChat={onClickLeaveChat}
        onClickEnterChat={onClickEnterChat}
      />
    </div>
  ) : (
    <>
      <ListTab privateTab={privateTab} onClickPrivateTab={onClickPrivateTab} />
      <UserList
        userList={userList}
        voiceChatType={voiceChatType}
        privateChatStatus={privateChatStatus}
        sendCall={sendCall}
        getUserAttributes={getUserAttributes}
        onClickLeaveChat={onClickLeaveChat}
        onClickEnterChat={onClickEnterChat}
        currentChatMode={currentChatMode}
      />
    </>
  );
};

export default List;
